/* HideShow Mobile */

/* The license for this script is GNU General Public License */
/* https://www.gnu.org/licenses/gpl.html */

( function( ) { // opens document ready

/* Hide/Show top navigation menu in mobile size screens */
	// define global variables to hold data
	const pageWrap = document.querySelector( "#wrapper" );
	const menuButton = document.querySelector( ".button__menu" );
	const searchButton = document.querySelector( ".button__search" );
	const customMenu = document.querySelector( "#main-menu" );
	const searchBox = document.querySelector( "#searchbox" );
	const searchInput = document.querySelector( ".searchbox__header .search-input" );
	
	function reveal( element, toggleAdd, toggleRemove ) {
		/*
	 	* element = html element by class or id
	 	* toggleAdd = animation class to add
	 	* toggleRemove = animation class to remove
	 	*/
	 	element.setAttribute( "aria-expanded", "true" );
	 	element.classList.add( toggleAdd );
	 	element.classList.remove( toggleRemove );
	}
	
	function conceal( element, toggleAdd, toggleRemove ) {
		/*
	 	 * element = html element by class or id
	 	 * toggleAdd = animation class to add
	 	 * toggleRemove = animation class to remove
	 	*/
	 	element.setAttribute( "aria-expanded", "false" );
	 	element.classList.remove( toggleRemove );
	 	element.classList.add( toggleAdd );
	}
	
	function toggleMenuMobile() {
		if ( menuButton ) {
			menuButton.addEventListener( "click", () => {
				
				// If the menu is not expanded
				if ( customMenu.getAttribute( "aria-expanded" ) === "false" ) {
					
					// Expand
					reveal( customMenu, "slideDown", "slideUp" );
					menuButton.setAttribute( "aria-pressed", "true" );
				} else {
					
					// Close menu
					conceal( customMenu, "slideUp", "slideDown" );
					menuButton.setAttribute( "aria-pressed", "false" );
				}
			} );
		}
	}

	function hideShowMenu() {
		const windowWidth = window.innerWidth;
		//console.log(windowWidth);
		
		if ( menuButton ) {
			if ( windowWidth <= 640 ) {
				menuButton.setAttribute( "aria-pressed", "false" );
				customMenu.setAttribute( "aria-expanded", "false" );
			} else {
				menuButton.setAttribute( "aria-pressed", "true" );
				customMenu.setAttribute( "aria-expanded", "true" );
			}
		}
	}
	
	toggleMenuMobile(); 
	hideShowMenu();

	let resizeId;

	window.onresize = function() {
		clearTimeout( resizeId );
		resizeId = setTimeout( hideShowMenu, 250 );
	};

} )(); // closes document ready
